import React from 'react';
import ContentLoader from './ThemedContentLoader';

const FinanceCashInOutPreloader = (props) => (
  <ContentLoader
    speed={2}
    width={210}
    height={157}
    viewBox="0 0 210 157"
    {...props}
  >
    <rect x="25" y="45" rx="3" ry="3" width="80" height="12" />
    <rect x="25" y="20" rx="3" ry="3" width="90" height="16" />
    <rect x="25" y="85" rx="3" ry="3" width="80" height="12" />
    <rect x="25" y="110" rx="3" ry="3" width="90" height="16" />
  </ContentLoader>
);

export default FinanceCashInOutPreloader;
